import userRoles from '../../shared/authorization/userRoles';
import { assignmentTypes } from '../../shared/authorization/assignmentTypes';
import assignmentPermissions from '../../shared/authorization/assignmentPermissions';

const canUserEditRolesForClient = ({ roleName, assignments }) =>
  roleName === userRoles.POWER_USER || roleName === userRoles.SUPER_USER
  || assignments.find(({ assignmentType }) =>
    assignmentType === assignmentTypes.USER)?.privileges.some(({ privilegeCode }) =>
    privilegeCode === assignmentPermissions.UserAdmin);

export const getClientsSetWithEditPermissionsForUser = loggedInUser => loggedInUser.clients.reduce(
  (acc, { clientId, ...client }) => {
    if (canUserEditRolesForClient(client)) {
      acc.add(clientId);
    }
    return acc;
  }, new Set());

export const createRoleRow = () => ({
  roleId: 0,
  roleName: '',
  description: '',
  clientId: null,
  allowEdit: true,
  allowDelete: true,
  privilegeList: [],
});

export const selectFirstRow = gridApi => {
  const firstRow = gridApi.getDisplayedRowAtIndex(0);
  if (firstRow) {
    firstRow.setSelected(true, true);
  }
};

export const parseRoles = (roles, clients) =>
  roles.map(role => ({
    ...role,
    clientName: clients?.find(({ clientId }) => clientId === role.clientId)?.shortName,
    privilegeList: role.privilegeList?.split(','),
  }));
